<template>
  <v-dialog v-model="active" max-width="500px" persistent>
    <v-card>
      <v-card-title class="success py-4">
        <v-row class="d-flex justify-end">
          <v-btn fab dark x-small class="btn_style3" @click="cancel()"
            ><v-icon dark>fa-times</v-icon></v-btn
          >
        </v-row>
      </v-card-title>
      <v-card-text class="py-2 my-0">
        <v-container class="m-auto">
          <h2 class="font-font-weight-bold text-center">
            {{ title ? title : "Escribe el titulo" }}
          </h2>
        </v-container>
      </v-card-text>
      <v-card-actions class="d-flex justify-center pb-4">
        <v-btn color="error" @click="cancel()"> NO </v-btn>
        <v-btn color="primary" @click="accept()"> SI </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["title", "active"],
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    accept() {
      this.$emit("accept");
    },
  },
};
</script>
